import React from 'react';

function Leadership() {
  const leadershipData = [
    {
      name: 'PURNA MOHANTY',
      title: 'Founder and CEO',
      img: './images/leaders/Purna.jpg',
      alt: 'Purna Mohanty - Marquee Semiconductor',
      description: `Purna brings over 32 years of experience across engineering, business development, sales, marketing, and operations. His passion for Silicon Valley’s culture of innovation inspired him to establish Marquee Semiconductor, building R&D hubs in globally strategic locations. Prior to founding both companies, he held executive roles at Tessolve, Broadcom, NXP, and Adaptec, and co-founded multiple successful startups. Purna holds five US patents in SoC design and verification, a BSEE from NIT Rourkela, and an MSEE from the University of Toledo, Ohio.`,
      isImageLeft: true,
      bg: 'bg-light',
    },
    {
      name: 'Don Smith',
      title: 'Silicon Architect',
      img: './images/leaders/Don.jpg',
      alt: 'Don Smith - Marquee Semiconductor',
      description: `Don brings 30+ years of experience in system-level silicon architecture, with a strong focus on high-performance and low-power design. His expertise spans analog/mixed-signal and digital SoCs. Prior to joining Marquee, Don held senior engineering positions at Hittite Microwave, Crimson Microsystems, Ciena Corp., and Oak Technology. He holds an MS in Electrical Engineering from Stanford and a BS in Physics from CSU Sacramento.`,
      isImageLeft: false,
      bg: '',
    },
    {
      name: 'Jeetu Kar',
      title: 'Simulation Engineering',
      img: './images/leaders/Jeetu.jpg',
      alt: 'Jeetu Kar - Marquee Semiconductor',
      description: `Jeetu, leads the verification efforts with a focus on technical excellence and delivery. With over 13 years of experience in SoC and IP-level verification, he has built and scaled high-performing teams that consistently meet complex engineering demands. Jeetu’s leadership plays a vital role in driving quality, innovation, and collaboration across the organization. He holds a degree in Electronics and Communication Engineering from Biju Patnaik University of Technology, India.`,
      isImageLeft: true,
      bg: 'bg-light',
    },
    {
      name: 'Benedict Joseph Guevarra',
      title: 'Simulation Engineering',
      img: './images/leaders/Benny.jpg',
      alt: 'Benedict Joseph Guevarra - Marquee Semiconductor',
      description: `Benedict is a founding member and senior engineering leader, overseeing the company’s global design verification efforts. With over 15 years of experience, he has built high-performing teams focused on delivery excellence. His leadership is rooted in a clear vision: a motivated, skilled, and results-driven organization. Prior to joining the company, he held technical leadership roles at Wave Computing and Canon. He holds a degree in Electronics and Communications Engineering from the University of Santo Tomas, Philippines.`,
      isImageLeft: false,
      bg: '',
    },
    {
      name: 'Rocky Arce',
      title: 'Software Engineering',
      img: './images/leaders/Rocky.jpg',
      alt: 'Rocky Arce - Marquee Semiconductor',
      description: `With his 18+ years of experience managing complex silicon programs across global teams. He brings deep expertise in pre- and post-silicon validation, firmware development, and FPGA prototyping, ensuring first-time-right delivery of advanced semiconductor solutions. At Marquee, he leads cross-functional execution and customer engagement across critical accounts. Rocky previously held senior engineering roles at Wave Computing and Canon. He earned his BS in Electronics and Communications Engineering from Ateneo de Manila University, Philippines.`,
      isImageLeft: true,
      bg: 'bg-light',
    },
    {
      name: 'Abinash Sahu',
      title: 'Software Engineering',
      img: './images/leaders/Abi.jpg',
      alt: 'Abinash Sahu - Marquee Semiconductor',
      description: `With deep expertise in full-stack development and platform delivery, and nearly a decade of experience, he leads design, development, and DevOps efforts at Marquee, overseeing scalable internal tools and customer-facing solutions. Abinash holds a Master’s degree in Computer Applications from NIST University, Berhampur, India.`,
      isImageLeft: false,
      bg: '',
    },
    {
      name: 'Hara Prasad Mohanty',
      title: 'Chief Financial Officer and Vice President of APAC Operations',
      img: './images/leaders/Hara.jpg',
      alt: 'Hara Prasad Mohanty - Marquee Semiconductor',
      description: `Hara brings over 24 years of expertise in finance, tax, and strategic expansion within the FMCG and technology sectors. At Marquee, he leads APAC operations and plays a critical role in driving growth across ASEAN and North Asia. He also engages directly with government agencies and trade groups to promote innovation adoption. Hara is a Chartered Accountant and a member of both the ICAI and CPA Australia.`,
      isImageLeft: true,
      bg: 'bg-light',
    },
    {
      name: 'Niranjan Tripathy',
      title: 'Chief People Officer',
      img: './images/leaders/Niranjan.jpg',
      alt: 'Niranjan Tripathy - Marquee Semiconductor',
      description: `With over 35 years of experience in technology and research, Niranjan brings deep leadership and people expertise to Marquee. His career spans impactful roles at NASA, Bhabha Atomic Research Centre, and Fujitsu. A passionate advocate for learning, Niranjan supports the company’s growth through strong culture-building and organizational scaling. He holds advanced degrees in Physics and Computer Science from Utkal University and the UK.`,
      isImageLeft: false,
      bg: '',
    },
  ];

  const Section = ({ isImageLeft, img, alt, name, title, description, bg }) => (
    <div className={`container-fluid p-5 ${bg}`}>
      <div className="row">
        <div className="col-md-12">
          <div className="container">
            <div className="row align-items-center">
              {isImageLeft && (
                <div className="col-md-3 d-flex align-items-center justify-content-center p-4">
                  <img src={img} alt={alt} className="img-fluid rounded-circle shadow" />
                </div>
              )}
              <div className="col-md-9 d-flex align-items-center justify-content-center">
                <div>
                  <p className="text-uppercase text-mcolor">
                    <span className="blockquote">{name},</span> {title}
                  </p>
                  <p style={{ textAlign: 'justify' }}>{description}</p>
                </div>
              </div>
              {!isImageLeft && (
                <div className="col-md-3 d-flex align-items-center justify-content-center p-4">
                  <img src={img} alt={alt} className="img-fluid rounded-circle shadow" />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12 LeadershipBanner text-white py-5">
            <div className="inner-heading">
              <h1 className="text-uppercase display-6">Leadership</h1>
              <p className="blockquote">Who knows the way, goes the way, and shows the way.</p>
            </div>
          </div>
        </div>
      </div>

      <div className="container py-5">
        <div className="row">
          <div className="col-md-12 text-center">
            <h3 className="text-uppercase text-mcolor">Leadership</h3>
            <p>
              Good Leaders are the true mentors to enable people to turn the resources they have into the power they
              need to make the change they want. Marquee Semiconductor is established by technologists in the
              semiconductor industry from different parts of the world who have translated their vision into reality.
            </p>
          </div>
        </div>
      </div>

      {leadershipData.map((leader, idx) => (
        <Section key={idx} {...leader} />
      ))}
    </>
  );
}

export default Leadership;
